/* Chef Hassan's Kitchen: the order ticket (cart drawer and cart page), the event
   details form with its calendar, and add-to-order buttons. Uses Shopify's cart AJAX API.
   Plain JavaScript, no dependencies. */
(function () {
  'use strict';
  var C = window.CHK || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var KEYS = { date: 'Pickup / delivery date', time: 'Pickup / delivery time', guests: 'Guests', notes: 'Delivery notes', dietary: 'Dietary needs', phone: 'Contact phone' };
  var SERVICE_HANDLES = ['full-catering-service-add-on', 'on-site-cooking', 'pasta-station', 'omlette-station', 'smoothie-station', 'on-site-salad-bar', 'coffee-tea-station', 'luxurious-food-table-design', 'chaffer-rentals', 'cutlery-rentals', 'beverages', 'office-lunch-catering-package'];
  var TIMES = [];
  for (var i = 0; i < 31; i++) {
    var mins = 7 * 60 + i * 30, h = Math.floor(mins / 60), m = mins % 60;
    TIMES.push((((h + 11) % 12) + 1) + ':' + (m ? '30' : '00') + ' ' + (h < 12 ? 'AM' : 'PM'));
  }

  /* ---------------------------------------------------------------- helpers */
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
  var money = function (cents) { return fmt.format(cents / 100); };

  // Today's date in Toronto, plus an offset, as YYYY-MM-DD.
  function torontoDate(offset) {
    var today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto' }).format(new Date());
    var d = new Date(today + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + (offset || 0));
    return d.toISOString().slice(0, 10);
  }
  var fromIso = function (s) { return new Date(s + 'T12:00:00Z'); };
  var longDate = function (s) { return fromIso(s).toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }); };
  var shortDate = function (s) { return fromIso(s).toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' }); };

  // A phone number we can call: 10 to 15 digits, however it's punctuated.
  var phoneOk = function (s) { var n = String(s || '').replace(/\D/g, ''); return n.length >= 10 && n.length <= 15; };

  var earliest = function () { return torontoDate(C.leadDays); };
  var trayReady = function () { return torontoDate(C.trayLeadDays); };

  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || e.message || 'Request failed'); });
      return r.json();
    });
  }

  /* ------------------------------------------------------------------ state */
  var cart = null;
  var printed = {};
  var pending = null;
  var mounts = [];
  var attr = function (k) { var v = cart && cart.attributes && cart.attributes[k]; return v ? String(v) : ''; };

  function refresh() {
    return json(C.root + 'cart.js?' + Date.now()).then(function (c) { cart = c; paint(); return c; });
  }

  function change(key, quantity) {
    return json(C.cartChangeUrl + '.js', { id: key, quantity: quantity }).then(function (c) { cart = c; paint(); });
  }

  function setAttributes(values) {
    return json(C.cartUpdateUrl + '.js', { attributes: values }).then(function (c) { cart = c; paint(); });
  }

  // What a tray line feeds: regular trays about 15 people, large about 25.
  function feeds(item) {
    var size = (item.options_with_values || []).map(function (o) { return o.value; }).join(' ');
    if (/\bLarge\b/.test(size)) return 'feeds about ' + item.quantity * 25;
    if (/\bRegular\b/.test(size)) return 'feeds about ' + item.quantity * 15;
    return '';
  }

  /* --------------------------------------------------------------- calendar */
  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var isoOf = function (d) { return d.toISOString().slice(0, 10); };

  function calendar(host, opts) {
    var selected = opts.value || '';
    var min = earliest(), soon = trayReady();
    var start = fromIso(selected || min);
    var month = { y: start.getUTCFullYear(), m: start.getUTCMonth() };
    var open = false;

    host.className = 'CalendarPicker-picker';
    host.innerHTML =
      '<input type="hidden" name="' + opts.name + '">' +
      '<button type="button" id="' + opts.id + '" class="CalendarPicker-trigger" aria-expanded="false" aria-controls="' + opts.id + '-calendar">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M3.5 9.5h17M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.5"/></svg>' +
      '<span></span></button><div data-cal-slot></div>';
    var hidden = $('input', host), trigger = $('button', host), slot = $('[data-cal-slot]', host), label = $('span', trigger);

    function sync() {
      hidden.value = selected;
      trigger.dataset.empty = String(!selected);
      label.textContent = selected ? longDate(selected) : 'Choose your pickup / delivery date';
    }

    function draw() {
      trigger.setAttribute('aria-expanded', String(open));
      if (!open) { slot.innerHTML = ''; return; }
      var first = new Date(Date.UTC(month.y, month.m, 1, 12));
      var count = new Date(Date.UTC(month.y, month.m + 1, 0, 12)).getUTCDate();
      var cells = '';
      for (var b = 0; b < first.getUTCDay(); b++) cells += '<span></span>';
      for (var d = 1; d <= count; d++) {
        var day = isoOf(new Date(Date.UTC(month.y, month.m, d, 12)));
        var off = day < min, short = !off && day < soon;
        cells += '<button type="button" class="CalendarPicker-day" data-day="' + day + '"' + (off ? ' disabled' : '') +
          ' data-selected="' + (day === selected) + '" data-soon="' + short + '" aria-pressed="' + (day === selected) + '"' +
          ' aria-label="' + esc(longDate(day) + (off ? ', unavailable' : short ? ', short notice' : '')) + '" tabindex="' + (day === (selected || min) ? 0 : -1) + '">' + d + '</button>';
      }
      var atMin = month.y === fromIso(min).getUTCFullYear() && month.m === fromIso(min).getUTCMonth();
      slot.innerHTML =
        '<div id="' + opts.id + '-calendar" class="CalendarPicker-panel" role="dialog" aria-label="Choose your pickup / delivery date">' +
        '<div class="CalendarPicker-head"><button type="button" data-shift="-1"' + (atMin ? ' disabled' : '') + ' aria-label="Previous month">‹</button>' +
        '<p aria-live="polite">' + esc(first.toLocaleDateString('en-CA', { month: 'long', year: 'numeric', timeZone: 'UTC' })) + '</p>' +
        '<button type="button" data-shift="1" aria-label="Next month">›</button></div>' +
        '<div class="CalendarPicker-weekdays" aria-hidden="true">' + WEEKDAYS.map(function (w) { return '<span>' + w + '</span>'; }).join('') + '</div>' +
        '<div class="CalendarPicker-grid">' + cells + '</div>' +
        '<p class="CalendarPicker-legend"><span class="CalendarPicker-dot" aria-hidden="true"></span> Short notice: most catering trays need ' + C.trayLeadDays + ' days, so we\'ll confirm your dishes.</p></div>';
    }

    function focusDay(day) {
      var el = $('[data-day="' + day + '"]', slot);
      if (el) el.focus();
    }

    function close(refocus) { open = false; draw(); if (refocus) trigger.focus(); }

    trigger.addEventListener('click', function () {
      open = !open; draw();
      if (open) focusDay(selected || $$('[data-day]:not([disabled])', slot).map(function (b) { return b.dataset.day; })[0]);
    });
    slot.addEventListener('click', function (e) {
      var s = e.target.closest('[data-shift]');
      if (s) { var d = new Date(Date.UTC(month.y, month.m + Number(s.dataset.shift), 1)); month = { y: d.getUTCFullYear(), m: d.getUTCMonth() }; draw(); return; }
      var b = e.target.closest('[data-day]');
      if (!b || b.disabled) return;
      selected = b.dataset.day; sync(); close(true);
      if (opts.onChange) opts.onChange(selected);
    });
    slot.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(true); return; }
      var step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
      var cur = document.activeElement && document.activeElement.dataset && document.activeElement.dataset.day;
      if (!step || !cur) return;
      e.preventDefault();
      var next = fromIso(cur); next.setUTCDate(next.getUTCDate() + step);
      var nextIso = isoOf(next);
      if (next.getUTCMonth() !== month.m) { month = { y: next.getUTCFullYear(), m: next.getUTCMonth() }; draw(); }
      requestAnimationFrame(function () { focusDay(nextIso); });
    });
    sync();
    return { set: function (v) { selected = v || ''; sync(); if (open) draw(); }, get: function () { return selected; } };
  }

  /* ----------------------------------------------------------- ticket mount */
  function skeleton(variant) {
    var checkout = '<div class="OrderTicket-checkoutBar" data-checkout></div>';
    return '<div class="OrderTicket-wrap" data-variant="' + variant + '">' +
      '<div class="OrderTicket-ticket" data-ticket></div>' +
      '<div class="OrderTicket-details">' +
      '<form class="EventDetailsForm-form" data-details novalidate><fieldset><legend>Event details</legend>' +
      '<div class="EventDetailsForm-field"><label for="eventDate-' + variant + '">Pickup / delivery date <span class="req">*</span></label><div data-cal></div></div>' +
      '<div class="EventDetailsForm-row">' +
      '<div class="EventDetailsForm-field"><label for="eventTime-' + variant + '">Pickup / delivery time</label><select id="eventTime-' + variant + '" name="eventTime" class="input"><option value="">Choose a time</option>' + TIMES.map(function (t) { return '<option>' + t + '</option>'; }).join('') + '</select></div>' +
      '<div class="EventDetailsForm-field"><label for="guests-' + variant + '">Guests</label><input id="guests-' + variant + '" name="guests" type="number" min="1" inputmode="numeric" class="input" placeholder="How many?"></div></div>' +
      '<div class="EventDetailsForm-field"><label for="phone-' + variant + '">Contact phone number <span class="req">*</span></label><input id="phone-' + variant + '" name="phone" type="tel" inputmode="tel" autocomplete="tel" maxlength="30" class="input" placeholder="Best number to reach you" required aria-required="true"></div>' +
      '<div class="EventDetailsForm-field"><label for="deliveryNotes-' + variant + '">Delivery notes</label><textarea id="deliveryNotes-' + variant + '" name="deliveryNotes" class="input" rows="2" maxlength="600" placeholder="Address details, buzzer, parking, loading dock, setup location…"></textarea></div>' +
      '<div class="EventDetailsForm-field"><label for="dietary-' + variant + '">Dietary restrictions &amp; allergies</label><textarea id="dietary-' + variant + '" name="dietary" class="input" rows="2" maxlength="600" placeholder="e.g. 4 vegetarian, 1 nut allergy, no pork"></textarea></div>' +
      '<div class="EventDetailsForm-saveRow"><button class="button button--secondary" type="submit">Save details</button><p role="status" class="EventDetailsForm-status" data-status></p></div>' +
      '</fieldset></form>' +
      '<a class="OrderTicket-addOns" data-addons href="' + C.root + 'collections/on-site-services"><span class="OrderTicket-addOnsText"><b>Need servers, a live station or rentals?</b><span>Orders without Full Catering Service are delivered drop-off. Browse add-ons &amp; services →</span></span></a>' +
      (variant === 'page'
        ? '<form class="OrderTicket-note" method="post" action="' + C.cartUpdateUrl + '" data-note><label for="note">Event details or special requests</label><textarea id="note" name="note" class="input" placeholder="Theme, allergies, delivery instructions…"></textarea><button class="button button--secondary" type="submit">Save note</button><p role="status" class="EventDetailsForm-status" data-note-status></p></form>' + checkout
        : '<a href="' + C.cartUrl + '" class="OrderTicket-fullLink">View full order &amp; add a note →</a>') +
      '</div>' + (variant === 'drawer' ? checkout : '') + '</div>';
  }

  function mount(host, variant) {
    host.innerHTML = skeleton(variant);
    var wrap = $('.OrderTicket-wrap', host);
    var m = { host: host, variant: variant, wrap: wrap, cal: null, dirty: false };
    m.cal = calendar($('[data-cal]', wrap), { id: 'eventDate-' + variant, name: 'eventDate', value: '', onChange: function () { m.dirty = true; } });

    var form = $('[data-details]', wrap);
    form.addEventListener('input', function () { m.dirty = true; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var status = $('[data-status]', wrap);
      var get = function (n) { return (form.elements[n] ? form.elements[n].value : '').trim(); };
      var date = m.cal.get(), guests = get('guests');
      var fail = function (t) { status.className = 'EventDetailsForm-error'; status.textContent = t; };
      if (!date) return fail('Choose the date of your pickup or delivery.');
      if (date < earliest()) return fail('We need at least ' + C.leadDays + ' days to prepare. The earliest date is ' + shortDate(earliest()) + '. For anything sooner, call or email us.');
      var phone = get('phone');
      if (!phone) return fail('Add a phone number so we can reach you about your order.');
      if (!phoneOk(phone)) return fail('Enter a phone number we can call, including the area code.');
      var n = guests ? Math.floor(Number(guests)) : null;
      if (n !== null && (!isFinite(n) || n < 1 || n > 5000)) return fail('Enter your guest count as a number.');
      var attrs = {};
      attrs[KEYS.date] = date; attrs[KEYS.time] = get('eventTime'); attrs[KEYS.guests] = n ? String(n) : '';
      attrs[KEYS.notes] = get('deliveryNotes').slice(0, 600); attrs[KEYS.dietary] = get('dietary').slice(0, 600);
      attrs[KEYS.phone] = phone.slice(0, 30);
      var btn = $('button[type=submit]', form); btn.disabled = true; btn.textContent = 'Saving…';
      setAttributes(attrs).then(function () { m.dirty = false; status.className = 'EventDetailsForm-status'; status.textContent = 'Saved to your order.'; })
        .catch(function () { fail("Couldn't save your details. Please try again."); })
        .then(function () { btn.disabled = false; btn.textContent = 'Save details'; });
    });

    var note = $('[data-note]', wrap);
    if (note) note.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = $('[data-note-status]', wrap);
      json(C.cartUpdateUrl + '.js', { note: $('textarea', note).value.slice(0, 2000) })
        .then(function (c) { cart = c; s.textContent = 'Saved.'; })
        .catch(function () { s.className = 'EventDetailsForm-error'; s.textContent = "Couldn't save your note."; });
    });

    wrap.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) { change(q.dataset.key, Number(q.dataset.qty)); return; }
      var co = e.target.closest('[data-checkout] a');
      if (co && !(attr(KEYS.date) && attr(KEYS.date) >= earliest() && phoneOk(attr(KEYS.phone)))) { e.preventDefault(); paint(); return; }
      if (e.target.closest('[data-need-phone]')) {
        var p = $('#phone-' + variant, wrap);
        if (p) { p.scrollIntoView({ behavior: 'smooth', block: 'center' }); p.focus(); }
        return;
      }
      if (e.target.closest('[data-need-date]')) {
        var t = $('#eventDate-' + variant, wrap);
        if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (t.getAttribute('aria-expanded') !== 'true') t.click(); }
      }
    });
    mounts.push(m);
    return m;
  }

  function paintMount(m) {
    var c = cart, w = m.wrap, eventDate = attr(KEYS.date);
    // A date saved earlier can fall inside the lead time as days pass; ask again if so.
    if (eventDate && eventDate < earliest()) eventDate = '';
    var guests = Number(attr(KEYS.guests)) || 0;
    var subtotal = c.items_subtotal_price;

    var lines = c.items.map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' · ');
      var f = feeds(it);
      var meta = [opts, f].filter(Boolean).join(' · ');
      var fresh = !printed[it.key];
      printed[it.key] = true;
      var img = it.image && !/ck_logo_compressed|chefhassanlogo/.test(it.image) ? it.image.replace(/(\.\w+)(\?|$)/, '_96x96$1$2') : '';
      return '<li class="OrderTicket-line" data-print="' + fresh + '">' +
        '<a href="' + esc(it.url) + '" class="OrderTicket-thumb" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span>CHK</span>') + '</a>' +
        '<div class="OrderTicket-info"><a href="' + esc(it.url) + '" class="OrderTicket-name">' + esc(it.product_title) + '</a>' +
        '<span class="OrderTicket-meta">' + esc(meta) + '</span>' +
        '<div class="OrderTicket-qty"><button type="button" data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="One fewer ' + esc(it.product_title) + '">−</button>' +
        '<span aria-label="Quantity">' + it.quantity + '</span>' +
        '<button type="button" data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="One more ' + esc(it.product_title) + '">+</button>' +
        '<button type="button" class="OrderTicket-remove" data-key="' + esc(it.key) + '" data-qty="0">Remove</button></div></div>' +
        '<span class="OrderTicket-price">' + (it.price === 0 ? 'TBC' : money(it.line_price)) + '</span></li>';
    }).join('');
    if (pending) {
      lines += '<li class="OrderTicket-line OrderTicket-pendingLine" data-print="true" aria-live="polite"><span class="OrderTicket-thumb" aria-hidden="true"><span>CHK</span></span><div class="OrderTicket-info"><span class="OrderTicket-name">' + esc(pending) + '</span><span class="OrderTicket-meta">Printing onto your ticket…</span></div><span class="OrderTicket-price">…</span></li>';
    }

    var orderNo = (c.token || '').replace(/\W/g, '').slice(0, 4).toUpperCase() || 'NEW';
    var stamp = eventDate ? '<div class="OrderTicket-stamp" aria-hidden="true">Booked<small>' + esc(shortDate(eventDate).split(',')[1] || '') + '</small></div>' : '';
    var per = guests ? 'About ' + money(subtotal / guests) + ' per guest. ' : '';
    $('[data-ticket]', w).innerHTML = stamp +
      '<div class="OrderTicket-head"><span>Order ' + orderNo + '</span><span>Chef Hassan\'s Kitchen</span></div>' +
      '<p class="OrderTicket-title">' + (guests ? 'Your order for ' + guests : 'Your order') + '</p>' +
      '<ul class="OrderTicket-lines">' + lines + '</ul>' +
      '<div class="OrderTicket-total"><span>Subtotal</span><b>' + money(subtotal) + '</b></div>' +
      '<p class="OrderTicket-small">' + per + 'Taxes, delivery and discount codes are added at checkout.</p>';

    // The form fills from the cart once, and again only if nothing is half-typed.
    if (!m.dirty) {
      var f = $('[data-details]', w).elements;
      m.cal.set(eventDate);
      f.eventTime.value = attr(KEYS.time);
      f.guests.value = attr(KEYS.guests);
      f.phone.value = attr(KEYS.phone);
      f.deliveryNotes.value = attr(KEYS.notes);
      f.dietary.value = attr(KEYS.dietary);
      var st = $('[data-status]', w);
      if (eventDate && phoneOk(attr(KEYS.phone)) && !st.textContent) st.textContent = 'Saved to your order.';
      var nt = $('[data-note] textarea', w);
      if (nt && document.activeElement !== nt) nt.value = c.note || '';
    }

    var hasAddOns = c.items.some(function (it) { return SERVICE_HANDLES.indexOf(it.handle) > -1; });
    $('[data-addons]', w).hidden = hasAddOns;

    $('[data-checkout]', w).innerHTML = !eventDate
      ? '<button type="button" class="button button--full" data-need-date>Choose your date to check out</button>'
      : !phoneOk(attr(KEYS.phone))
        ? '<button type="button" class="button button--full" data-need-phone>Add your phone number to check out</button>'
        : '<a href="' + C.root + 'checkout" class="button button--full">Check out · ' + money(subtotal) + '</a>';
  }

  function emptyMarkup() {
    return '<div class="CartDrawer-empty"><p class="CartDrawer-emptyTitle">Nothing on the ticket yet.</p>' +
      '<p>Start with a menu, or let the Event Planner build a spread for your headcount.</p>' +
      '<a href="' + C.root + 'pages/plan-your-event" class="button">Plan Your Event</a>' +
      '<a href="' + C.root + 'collections/catering" class="button button--secondary">Browse the Menus</a>' +
      '<a href="' + C.root + 'pages/contact" class="CartDrawer-quoteLink">Or ask for a custom quote →</a></div>';
  }

  var hosts = [];
  function paint() {
    if (!cart) return;
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = String(cart.items.length); b.hidden = cart.items.length === 0; });
    $$('[data-open-cart]').forEach(function (a) { a.setAttribute('aria-label', 'Your order, ' + cart.items.length + ' items'); });
    var empty = cart.items.length === 0 && !pending;
    hosts.forEach(function (h) {
      var m = h.mounted;
      if (empty) { h.el.innerHTML = h.variant === 'drawer' ? emptyMarkup() : emptyMarkup().replace('CartDrawer-empty', 'CartPage-empty'); h.mounted = null; mounts = mounts.filter(function (x) { return x !== m; }); return; }
      if (!m) { m = h.mounted = mount(h.el, h.variant); }
      paintMount(m);
    });
    void count;
  }

  /* ----------------------------------------------------------------- drawer */
  var panel = $('[data-cart-panel]'), scrim = $('[data-cart-scrim]');
  var returnFocus = null;
  function setOpen(on) {
    if (!panel) return;
    panel.dataset.open = String(on); scrim.dataset.open = String(on);
    if (on) { panel.removeAttribute('inert'); panel.focus(); } else { panel.setAttribute('inert', ''); if (returnFocus && returnFocus.focus) returnFocus.focus(); }
    document.body.style.overflow = on ? 'hidden' : '';
  }
  window.CHKCart = {
    open: function (detail) {
      returnFocus = document.activeElement;
      pending = (detail && detail.pending) || null;
      if (pending) window.setTimeout(function () { pending = null; paint(); }, 6000);
      setOpen(true); paint();
    },
    failed: function () { pending = null; setOpen(false); paint(); },
    refresh: refresh,
    add: function (items, attributes) {
      return json(C.cartAddUrl + '.js', { items: items }).then(function () {
        return attributes ? json(C.cartUpdateUrl + '.js', { attributes: attributes }) : null;
      }).then(function () { pending = null; return refresh(); });
    }
  };

  if (panel) {
    hosts.push({ el: $('[data-cart-body]', panel), variant: 'drawer', mounted: null });
    $('[data-cart-close]', panel).addEventListener('click', function () { setOpen(false); });
    scrim.addEventListener('click', function () { setOpen(false); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.dataset.open === 'true') setOpen(false); });
    // Tapping a dish or "view full order" leaves the page, so close first.
    panel.addEventListener('click', function (e) { if (e.target.closest('a[href]') && !e.target.closest('[data-need-date]') && !e.defaultPrevented) setOpen(false); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-open-cart]');
      if (!a || C.template === 'cart' || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      window.CHKCart.open();
    });
  }
  var page = $('[data-cart-page]');
  if (page) hosts.push({ el: page, variant: 'page', mounted: null });

  /* --------------------------------------------------------- add to order */
  // Product forms add without leaving the page and slide the ticket open.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[type=submit]', form), err = $('[data-product-error]', form);
    var id = form.elements.id && form.elements.id.value;
    var qty = Math.max(1, Math.floor(Number(form.elements.quantity ? form.elements.quantity.value : 1)) || 1);
    if (err) err.textContent = '';
    if (!id) { if (err) err.textContent = 'Choose an option first.'; return; }
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    window.CHKCart.add([{ id: Number(id), quantity: qty }])
      .then(function () { btn.textContent = 'Added'; window.CHKCart.open(); window.setTimeout(function () { btn.textContent = label; }, 1600); })
      .catch(function (x) { btn.textContent = label; if (err) err.textContent = x.message || "Couldn't add that to your order. Please try again."; })
      .then(function () { btn.disabled = false; });
  });

  refresh().catch(function () { /* the drawer simply stays empty */ });
})();
